import React from 'react'
import { Dropdown } from 'semantic-ui-react'

/**
 *
 * @param {object} props
 * @param {boolean} props.disabled
 * @param {number} props.value
 * @param {Array} props.languageOptions
 * @param {(_, event) => void} props.handleOnLanguageChange
 */
export default function SurveyLanguageDropdown({
  value,
  languageOptions,
  handleOnLanguageChange,
  disabled,
}) {
  return (
    <Dropdown
      disabled={disabled}
      value={value}
      selection
      options={languageOptions}
      onChange={handleOnLanguageChange}
      search
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyLanguageDropdown/index.js